import { render, staticRenderFns } from "./ListarTurmaPageAEE.vue?vue&type=template&id=1cc1242b&scoped=true"
import script from "./ListarTurmaPageAEE.vue?vue&type=script&lang=js"
export * from "./ListarTurmaPageAEE.vue?vue&type=script&lang=js"
import style0 from "./ListarTurmaPageAEE.vue?vue&type=style&index=0&id=1cc1242b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc1242b",
  null
  
)

export default component.exports